// Semáforo SLA de Valet compartido. Espeja EXACTAMENTE la lógica de `slaFor` en pages/Valet.jsx
// (columna "Solicitado"): tier rojo cuando mins > 15, ámbar 11–15, verde < 11.
// Fuente única para el Dashboard; no introduce reglas nuevas. Será configurable por sucursal más adelante.
//
// PURO (Fase 0 · dominio compartido Web/Native): sin navegador, UI, React, API ni storage.
// Movido desde lib/valetSla.js (que ahora re-exporta desde aquí). Comportamiento idéntico.
export const VALET_SLA = { proximo: 11, retraso: 15 };

export function slaTier(mins) {
  if (mins > VALET_SLA.retraso) return "red";
  if (mins >= VALET_SLA.proximo) return "orange";
  return "green";
}

export function slaLabel(tier) {
  return tier === "red" ? "Retrasado" : tier === "orange" ? "Próximo al límite" : "Normal";
}

// Minutos transcurridos desde una marca ISO (para conteo en vivo).
export function minsDesde(iso, nowMs = Date.now()) {
  if (!iso) return 0;
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return 0;
  return Math.max(0, Math.floor((nowMs - t) / 60000));
}
